import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  console.error(err);
});
